module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/martech_bg_mobile-bd7f224b0b6109a12370c5a623c4ff69.png";